const displayErrorLogNoProduction = error => {
  if (process.env.CONTEXT !== 'production') {
    /* eslint-disable-next-line no-console */
    console.error(error)
  }
}

export default displayErrorLogNoProduction
